var _g, _g2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgAppStore = function SvgAppStore(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Download_on_the_App_Store_Badge_US-UK_RGB_blk_092917",
    width: 107.599,
    height: 35.967,
    viewBox: "0 0 107.599 35.967",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1226",
    "data-name": "Group 1226",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1224",
    "data-name": "Group 1224"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1190",
    "data-name": "Path 1190",
    d: "M99.03,0H8.573c-.33,0-.655,0-.984,0-.275,0-.548.007-.826.011a11.882,11.882,0,0,0-1.8.159A5.993,5.993,0,0,0,3.252.736,5.789,5.789,0,0,0,1.8,1.8,5.627,5.627,0,0,0,.737,3.253,5.936,5.936,0,0,0,.175,4.965a11.683,11.683,0,0,0-.161,1.8C.005,7.041,0,7.317,0,7.593V28.377c0,.279.005.55.014.829a11.682,11.682,0,0,0,.161,1.8,5.923,5.923,0,0,0,.562,1.712A5.582,5.582,0,0,0,1.8,34.169a5.642,5.642,0,0,0,1.455,1.06,6.025,6.025,0,0,0,1.709.567,12.1,12.1,0,0,0,1.8.159c.278.006.551.01.826.01.329,0,.655,0,.984,0H99.03c.323,0,.652,0,.975,0,.274,0,.555,0,.829-.01a11.94,11.94,0,0,0,1.8-.159,6.118,6.118,0,0,0,1.716-.567,5.645,5.645,0,0,0,1.454-1.06,5.751,5.751,0,0,0,1.062-1.452,5.938,5.938,0,0,0,.557-1.712,12.144,12.144,0,0,0,.167-1.8c0-.279,0-.55,0-.829.007-.327.007-.652.007-.984V8.575c0-.329,0-.656-.007-.982,0-.276,0-.552,0-.828a12.141,12.141,0,0,0-.167-1.8,5.95,5.95,0,0,0-.557-1.711A5.814,5.814,0,0,0,104.348.736a6.085,6.085,0,0,0-1.716-.564,11.729,11.729,0,0,0-1.8-.159c-.274,0-.555-.01-.829-.011-.323,0-.652,0-.975,0Z",
    transform: "translate(0 0)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1191",
    "data-name": "Path 1191",
    d: "M7.681,35.268c-.274,0-.541,0-.813-.01a11.408,11.408,0,0,1-1.681-.147,5.291,5.291,0,0,1-1.49-.493,4.861,4.861,0,0,1-1.256-.914,4.784,4.784,0,0,1-.918-1.256,5.145,5.145,0,0,1-.488-1.49,11.162,11.162,0,0,1-.15-1.686c-.006-.19-.013-.821-.013-.821V7.681s.008-.622.013-.8a11.123,11.123,0,0,1,.149-1.683A5.175,5.175,0,0,1,1.524,3.7a4.832,4.832,0,0,1,.913-1.257A5,5,0,0,1,3.7,1.523a5.236,5.236,0,0,1,1.487-.489A11.317,11.317,0,0,1,6.87.886L7.682.875h92.407l.821.011a11.136,11.136,0,0,1,1.671.146,5.34,5.34,0,0,1,1.5.493A5.03,5.03,0,0,1,106.255,3.7a5.182,5.182,0,0,1,.481,1.483,11.687,11.687,0,0,1,.156,1.7c0,.255,0,.528,0,.8.007.337.007.658.007.982V27.481c0,.327,0,.645-.007.967,0,.292,0,.56,0,.836a11.451,11.451,0,0,1-.154,1.667,5.16,5.16,0,0,1-.486,1.5,4.928,4.928,0,0,1-.913,1.246,4.867,4.867,0,0,1-1.258.919,5.271,5.271,0,0,1-1.5.494,11.278,11.278,0,0,1-1.681.147c-.263.006-.539.01-.807.01l-.975,0Z",
    transform: "translate(-0.088 -0.088)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_Group_",
    "data-name": "<Group>",
    transform: "translate(8.966 7.841)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_Group_2",
    "data-name": "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_Group_3",
    "data-name": "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_Path_",
    "data-name": "<Path>",
    d: "M23.277,19.663A4.45,4.45,0,0,1,25.4,15.929a4.555,4.555,0,0,0-3.589-1.94c-1.51-.158-2.974.9-3.743.9s-1.969-.888-3.245-.862A4.779,4.779,0,0,0,10.8,16.484c-1.739,3.011-.442,7.436,1.224,9.869.833,1.192,1.807,2.523,3.082,2.476,1.247-.052,1.713-.8,3.218-.8s1.929.8,3.229.765c1.338-.022,2.182-1.2,2.986-2.4A9.857,9.857,0,0,0,25.9,23.618,4.3,4.3,0,0,1,23.277,19.663Z",
    transform: "translate(-9.972 -9.25)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Path_2",
    "data-name": "<Path>",
    d: "M21.71,11.859a4.381,4.381,0,0,0,1-3.139,4.458,4.458,0,0,0-2.884,1.492A4.169,4.169,0,0,0,18.8,13.235a3.686,3.686,0,0,0,2.91-1.376Z",
    transform: "translate(-10.861 -8.72)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1225",
    "data-name": "Group 1225",
    transform: "translate(21.99 8.228)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1192",
    "data-name": "Path 1192",
    d: "M41.508,26.226H37.252L36.23,29.244h-1.8l4.031-11.166h1.873l4.031,11.166H42.529Zm-3.815-1.393h3.374l-1.663-4.9h-.047Z",
    transform: "translate(-34.427 -17.892)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1193",
    "data-name": "Path 1193",
    d: "M54.3,25.5c0,2.53-1.354,4.155-3.4,4.155a2.76,2.76,0,0,1-2.561-1.424H48.3v4.032H46.631V21.433h1.617v1.354h.031a2.888,2.888,0,0,1,2.592-1.439C52.938,21.348,54.3,22.981,54.3,25.5Zm-1.718,0c0-1.648-.852-2.732-2.151-2.732-1.277,0-2.136,1.106-2.136,2.732s.859,2.739,2.136,2.739c1.3,0,2.151-1.076,2.151-2.739Z",
    transform: "translate(-35.658 -18.221)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1194",
    "data-name": "Path 1194",
    d: "M64.265,25.5c0,2.53-1.354,4.155-3.4,4.155a2.76,2.76,0,0,1-2.561-1.424h-.039v4.032H56.6V21.433h1.617v1.354h.031a2.888,2.888,0,0,1,2.592-1.439C62.9,21.348,64.265,22.981,64.265,25.5Zm-1.718,0c0-1.648-.852-2.732-2.151-2.732-1.277,0-2.136,1.106-2.136,2.732s.859,2.739,2.136,2.739c1.3,0,2.151-1.076,2.151-2.739Z",
    transform: "translate(-36.663 -18.221)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1195",
    "data-name": "Path 1195",
    d: "M71.519,26.112c.124,1.107,1.2,1.834,2.669,1.834,1.408,0,2.422-.727,2.422-1.725,0-.867-.611-1.386-2.058-1.741L73.1,24.131c-2.05-.5-3-1.454-3-3.01,0-1.927,1.679-3.25,4.063-3.25,2.359,0,3.977,1.323,4.031,3.25H76.51c-.1-1.114-1.022-1.787-2.368-1.787s-2.267.681-2.267,1.671c0,.789.588,1.254,2.028,1.61l1.23.3c2.291.542,3.243,1.462,3.243,3.1,0,2.089-1.664,3.4-4.311,3.4-2.476,0-4.148-1.278-4.256-3.3Z",
    transform: "translate(-37.995 -17.871)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1196",
    "data-name": "Path 1196",
    d: "M83.025,19.3v1.927h1.548V22.55H83.025v4.488c0,.7.31,1.022.99,1.022a5.223,5.223,0,0,0,.55-.039v1.315a4.589,4.589,0,0,1-.928.077c-1.648,0-2.291-.619-2.291-2.2V22.55H80.163V21.226h1.184V19.3Z",
    transform: "translate(-39.039 -18.015)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1197",
    "data-name": "Path 1197",
    d: "M86.065,25.5c0-2.561,1.509-4.171,3.861-4.171s3.862,1.61,3.862,4.171-1.494,4.171-3.862,4.171S86.065,28.07,86.065,25.5Zm6.02,0c0-1.757-.805-2.794-2.159-2.794s-2.158,1.045-2.158,2.794.8,2.793,2.158,2.793S92.085,27.266,92.085,25.5Z",
    transform: "translate(-39.634 -18.22)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1198",
    "data-name": "Path 1198",
    d: "M96.186,21.433H97.78v1.386h.039a1.942,1.942,0,0,1,1.958-1.471,2.577,2.577,0,0,1,.573.062v1.563a2.336,2.336,0,0,0-.751-.1,1.684,1.684,0,0,0-1.741,1.873v4.829H96.186Z",
    transform: "translate(-40.654 -18.221)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1199",
    "data-name": "Path 1199",
    d: "M108.561,27.181c-.225,1.478-1.664,2.492-3.505,2.492-2.368,0-3.838-1.587-3.838-4.132s1.478-4.21,3.768-4.21c2.252,0,3.669,1.547,3.669,4.016v.573H102.9v.1a2.12,2.12,0,0,0,2.19,2.306,1.842,1.842,0,0,0,1.88-1.145Zm-5.649-2.43h4.07a1.958,1.958,0,0,0-2-2.066,2.061,2.061,0,0,0-2.073,2.066Z",
    transform: "translate(-41.162 -18.22)",
    fill: "#fff"
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "_Group_4",
    "data-name": "<Group>",
    transform: "translate(32.074 7.586)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1227",
    "data-name": "Group 1227"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1200",
    "data-name": "Path 1200",
    d: "M37.609,8.73A2.373,2.373,0,0,1,40.133,11.4a2.385,2.385,0,0,1-2.525,2.7H35.671V8.73Zm-1.1,4.606h1.012a1.687,1.687,0,0,0,1.769-1.93,1.691,1.691,0,0,0-1.769-1.919H36.5Z",
    transform: "translate(-35.671 -8.466)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1201",
    "data-name": "Path 1201",
    d: "M41.68,12.209a1.918,1.918,0,1,1,3.819,0,1.918,1.918,0,1,1-3.819,0Zm3,0c0-.878-.394-1.391-1.086-1.391s-1.085.513-1.085,1.391S42.9,13.6,43.59,13.6,44.677,13.09,44.677,12.209Z",
    transform: "translate(-36.276 -8.605)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1202",
    "data-name": "Path 1202",
    d: "M51.069,14.244H50.24L49.4,11.262H49.34l-.833,2.982h-.821l-1.116-4.049h.81l.725,3.09h.06L49,10.195h.767l.832,3.09h.063l.722-3.09h.8Z",
    transform: "translate(-36.77 -8.614)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1203",
    "data-name": "Path 1203",
    d: "M53.854,10.186h.769v.643h.06a1.212,1.212,0,0,1,1.208-.721,1.317,1.317,0,0,1,1.4,1.506v2.621h-.8v-2.42c0-.651-.283-.974-.874-.974a.929.929,0,0,0-.967,1.026v2.369h-.8Z",
    transform: "translate(-37.504 -8.605)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1204",
    "data-name": "Path 1204",
    d: "M59.094,8.437h.8v5.629h-.8Z",
    transform: "translate(-38.033 -8.437)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1205",
    "data-name": "Path 1205",
    d: "M61.217,12.209a1.918,1.918,0,1,1,3.819,0,1.919,1.919,0,1,1-3.819,0Zm3,0c0-.878-.394-1.391-1.086-1.391s-1.085.513-1.085,1.391.391,1.394,1.085,1.394S64.214,13.09,64.214,12.209Z",
    transform: "translate(-38.246 -8.605)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1206",
    "data-name": "Path 1206",
    d: "M66.4,13.09c0-.729.543-1.149,1.506-1.209l1.1-.063v-.349c0-.428-.283-.669-.829-.669-.446,0-.755.164-.844.45h-.774c.082-.7.736-1.142,1.654-1.142,1.015,0,1.588.505,1.588,1.361v2.766H69.03v-.569h-.063a1.362,1.362,0,0,1-1.216.636A1.223,1.223,0,0,1,66.4,13.09Zm2.6-.346v-.339l-.989.063c-.558.037-.81.227-.81.584s.316.576.751.576A.954.954,0,0,0,69,12.744Z",
    transform: "translate(-38.769 -8.605)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1207",
    "data-name": "Path 1207",
    d: "M71.348,12.04c0-1.279.658-2.09,1.681-2.09a1.334,1.334,0,0,1,1.242.71h.06V8.437h.8v5.629h-.766v-.64H74.3a1.405,1.405,0,0,1-1.271.706C72,14.133,71.348,13.323,71.348,12.04Zm.825,0c0,.859.4,1.376,1.082,1.376s1.09-.524,1.09-1.372-.421-1.376-1.09-1.376-1.082.52-1.082,1.372Z",
    transform: "translate(-39.268 -8.437)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1208",
    "data-name": "Path 1208",
    d: "M79.229,12.209a1.918,1.918,0,1,1,3.819,0,1.918,1.918,0,1,1-3.819,0Zm3,0c0-.878-.394-1.391-1.086-1.391s-1.085.513-1.085,1.391S80.445,13.6,81.14,13.6,82.226,13.09,82.226,12.209Z",
    transform: "translate(-40.062 -8.605)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1209",
    "data-name": "Path 1209",
    d: "M84.669,10.186h.769v.643h.06a1.212,1.212,0,0,1,1.208-.721,1.317,1.317,0,0,1,1.4,1.506v2.621h-.8v-2.42c0-.651-.283-.974-.874-.974a.929.929,0,0,0-.967,1.026v2.369h-.8Z",
    transform: "translate(-40.611 -8.605)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1210",
    "data-name": "Path 1210",
    d: "M93.353,9.074V10.1h.877v.673h-.877v2.082c0,.424.175.61.573.61a2.667,2.667,0,0,0,.3-.018v.666a2.622,2.622,0,0,1-.435.041c-.889,0-1.243-.313-1.243-1.093V10.773h-.643V10.1h.643V9.074Z",
    transform: "translate(-41.341 -8.501)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1211",
    "data-name": "Path 1211",
    d: "M95.7,8.437H96.5v2.231h.063a1.246,1.246,0,0,1,1.235-.725,1.334,1.334,0,0,1,1.394,1.509v2.614h-.8V11.65c0-.647-.3-.974-.866-.974A.946.946,0,0,0,96.5,11.7v2.365h-.8Z",
    transform: "translate(-41.724 -8.437)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1212",
    "data-name": "Path 1212",
    d: "M104.353,13.142a1.644,1.644,0,0,1-1.754,1.171,1.839,1.839,0,0,1-1.87-2.09,1.867,1.867,0,0,1,1.867-2.115c1.127,0,1.806.77,1.806,2.041v.279h-2.859v.045a1.07,1.07,0,0,0,1.078,1.16.971.971,0,0,0,.963-.491Zm-2.811-1.3h2.045a.977.977,0,0,0-1-1.049,1.036,1.036,0,0,0-1.048,1.049Z",
    transform: "translate(-42.229 -8.605)",
    fill: "#fff"
  })))));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAppStore, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/appStore.6e2b823b.svg";
export { ForwardRef as ReactComponent };